<div class="group-invite-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="ya-invitation-content">
      <div class="invitation-content_header">
        <div class="group-icon">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi"></div>
        </div>
        <div class="content-container">
          <h2 class="title" [innerHTML]="welcomeLabel"></h2>
          <span class="text content-container--subfont" langkey="phGroupOrder_Invitation_Recieved_SubText"></span>
        </div>
      </div>
      <div class="name-inupt-form">
        <div class="ya-input-container">
          <div class="ya-input-wrapper">
            <div class="inputs-text">
              <input a11y_Input type="text" class="ya-input-text" (blur)="setWebView()" [placeholder]="inputPlaceholder"
                [formControl]="userNameInputFormControl">
            </div>
            <ng-container *ngIf="userNameInputFormControl.touched && userNameInputFormControl.invalid">
              <ng-container *ngIf="userNameInputFormControl.errors">
                <ng-container *ngIf="userNameInputFormControl.errors.minlength">
                  <ya-errorvalidation [controlValidation]="userNameInputFormControl.errors.minlength"
                    errorMessage="phGroupOrder_Input_Validate_Length"></ya-errorvalidation>
                </ng-container>
                <ng-container *ngIf="userNameInputFormControl.errors.forbiddenName">
                  <ya-errorvalidation [controlValidation]="userNameInputFormControl.errors.forbiddenName"
                    errorMessage="phGroupOrder_Input_Validate_Forbbiden_UserName"></ya-errorvalidation>
                </ng-container>
                <ng-container *ngIf="userNameInputFormControl.errors.required">
                  <ya-errorvalidation [controlValidation]="userNameInputFormControl.errors.required"
                    errorMessage="phGroupOrder_Input_Validate_Name"></ya-errorvalidation>
                </ng-container>
                <ng-container *ngIf="userNameInputFormControl.errors.pattern">
                  <ya-errorvalidation [controlValidation]="userNameInputFormControl.errors.pattern"
                    errorMessage="phGroupOrder_Input_Validate_Characters"></ya-errorvalidation>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="setBtnStateByUserName(); then activeButton else disableButton">
          </ng-container>
          <ng-template #activeButton>
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="joinGroupOrder()">
                <span langkey="phGroupOrder_Invitation_Recieved_Join_Btn"></span>
              </button>
            </div>
          </ng-template>
          <ng-template #disableButton>
            <div class="ya-webshop-button-container">
              <button mat-flat-button disabled>
                <span langkey="phGroupOrder_Invitation_Recieved_Join_Btn"></span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="ya-webshop-button-container webshop-ghost-button">
      <button mat-flat-button (click)="denyGroupOrder()">
        <span langkey="phGroupOrder_Invitation_Recieved_Deny_Btn"></span>
      </button>
    </div>
  </div>
</div>